// extracted by mini-css-extract-plugin
export default {"wrapper":"SortRule_wrapper__YLSfl","button-group":"SortRule_button-group__KiTTr","buttonGroup":"SortRule_button-group__KiTTr","select":"SortRule_select__LnPX-"};